/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockItemEditCtrl
 */
angular.module('mercury.modules.stock.item')
.directive('minStockOnHandPairValidator', function() {
  return {
    require: 'form',
    link: function(scope, elem, attrs, formCtrl) {
      scope.$watchGroup([
        'item.minimumStockOnHandQuantity',
        'item.minimumStockOnHandUnitId'
      ], function(values) {
        var qty = values[0];
        var unit = values[1];

        // Both empty: valid
        // Both filled: valid
        // Only one filled: invalid
        var valid = (!qty && !unit) || (!!qty && !!unit);

        formCtrl.$setValidity('minStockOnHandPair', valid);
      });
    }
  };
})

.controller('StockItemEditCtrl', ["$timeout", "itemId", "$q", "$scope", "StockBrands", "StockItemGroups", "StockItems", "StockSuppliers", "StockUnits", "SalesTax", "features", function($timeout, itemId, $q, $scope, StockBrands, StockItemGroups, StockItems, StockSuppliers, StockUnits, SalesTax, features) {
  $scope.item = StockItems.getStockApi(itemId, true);
  $scope.units = StockUnits.getAllActive();
  $scope.suppliers = StockSuppliers.getAll();
  $scope.brands = StockBrands.getAllActive();
  $scope.itemGroups = StockItemGroups.getAll();
  $scope.salesTaxes = SalesTax.getCompanySalesTaxAmounts();

  $scope.initialLoad = $q.all([
    $scope.item.$promise,
    $scope.units.$promise,
    $scope.suppliers.$promise,
    $scope.itemGroups.$promise,
    $scope.brands.$promise,
    $scope.salesTaxes
  ]);

  $scope.initialLoad.then(function() {
    $scope.item.globalPrice = Number($scope.item.currentPrice) || 0;
    
    if ($scope.item.defaultSupplierId && $scope.suppliers) {
      const defaultSupplier = $scope.suppliers.find(function(s) {
        return s.id === $scope.item.defaultSupplierId;
      });
      $scope.item.defaultSupplierName = defaultSupplier ? defaultSupplier.name : '';
    } else {
      $scope.item.defaultSupplierName = '';
    }

    if ($scope.item.defaultBrandId && $scope.brands) {
      const defaultBrand = $scope.brands.find(function(b) {
        return b.id === $scope.item.defaultBrandId;
      });
      $scope.item.defaultBrandName = defaultBrand ? defaultBrand.name : '';
    } else {
      $scope.item.defaultBrandName = '';
    }

    if ($scope.item.suppliers && $scope.suppliers) {
      $scope.item.suppliers.forEach(function(code) {
        const supplier = $scope.suppliers.find(function(s) { return s.id === code.supplierId; });
        code.supplierName = supplier ? supplier.name : '';

        const unit = $scope.units.find(function(u) { return u.id === code.unitId; });
        code.unitName = unit ? unit.name : '';

        const brand = $scope.brands.find(function(b) { return b.id === code.brandId; });
        code.brandName = brand ? brand.name : '';        
      });
    }

    // Normalize minimumStockOnHandQuantity and minimumStockOnHandUnitId
    if (!$scope.item.minimumStockOnHandQuantity) {
      $scope.item.minimumStockOnHandQuantity = null;
    }
    if (!$scope.item.minimumStockOnHandUnitId) {
      $scope.item.minimumStockOnHandUnitId = null;
      $scope.item.minimumStockOnHandUnitName = null;
      $scope.item.minimumStockOnHandUnitRatio = null;
    } else if ($scope.units) {
      const defaultUnit = $scope.units.find(function(s) {
        return s.id === $scope.item.minimumStockOnHandUnitId;
      });
      $scope.item.minimumStockOnHandUnitId = defaultUnit ? defaultUnit.id : null;
      $scope.item.minimumStockOnHandUnitName = defaultUnit ? defaultUnit.name : null;
      $scope.item.minimumStockOnHandUnitRatio = defaultUnit ? defaultUnit.ratio : null;
    }    

  });

  $scope.salesTaxes.then(function(result) {
    $scope.salesTaxes = result;
  });

  $scope.orderingUnitUpdated = function(newUnit) {
    $scope.item.currentPrice = ($scope.item.currentPrice * $scope.item.orderingUnitRatio) / newUnit.ratio;
    $scope.item.globalPrice = $scope.item.currentPrice;
    $scope.item.orderingUnitRatio = newUnit.ratio;
  };

  $scope.countingUnitUpdated = function(newUnit) {
    $scope.item.countingUnitId = newUnit.id;
    $scope.item.countingUnitName = newUnit.name;
    $scope.item.countingUnitRatio = newUnit.ratio;
  };

  $scope.minimumStockOnHandUnitUpdated = function(newUnit) {
    $scope.item.minimumStockOnHandUnitId = newUnit.id;
    $scope.item.minimumStockOnHandUnitName = newUnit.name;
    $scope.item.minimumStockOnHandUnitRatio = newUnit.ratio;
  };

  $scope.save = function() {
    $scope.itemSaving = StockItems.update($scope.item);
    $scope.itemSaving.then(function() {
      $scope.$close($scope.item);
    });
  };

  $scope.isStockCodeValid = true;

  $scope.addStockCode = function(supplier) {
    const newStockCode = $scope.item.name.replace(/\s+/g, '').substring(0, 5).toUpperCase() + "-" + Math.random().toString(36).substring(2, 7).toUpperCase();

    $scope.isStockCodeValid = true;
    $scope.item.suppliers.push({
      supplierId: supplier.id,
      supplierName: supplier.name,
      unitId: $scope.item.orderingUnitId,
      unitName: $scope.item.orderingUnitName,
      unitRatio: $scope.item.orderingUnitRatio,
      stockCode: newStockCode,
      unitCost: 0,
      brandId: $scope.item.defaultBrandId,
      brandName: $scope.item.defaultBrandName,
      stockItemId: $scope.item.id,
      globalSalesTaxRate: $scope.item.globalSalesTaxRate,
      defaultForSupplier: true      
    });
    
    $scope.updateDefaultForSupplier($scope.item.suppliers.length - 1);

    $scope.validateVariants();
  };

  $scope.codeUnitUpdate = function(supplierCode, newUnit) {
    supplierCode.unitCost = (supplierCode.unitCost * supplierCode.unitRatio) / newUnit.ratio;
    supplierCode.unitRatio = newUnit.ratio;
  };

  // Removes a supplier variant. If the removed variant is marked as the default for its supplier 
  // and other variants exist for that supplier, the first remaining variant is set as the new default.    
  $scope.removeStockCode = function (index) {
    if (!$scope.item.suppliers[index]) {
      return;
    }
  
    const deletedVariant = $scope.item.suppliers[index];

    if (!deletedVariant) {
      return;
    }

    $scope.item.suppliers.splice(index, 1);
    const supplierVariants = $scope.item.suppliers;

    // If there are other variants, set the last item of the array as the default
    if (deletedVariant.defaultForSupplier) {
      if (supplierVariants.length > 0) {
        supplierVariants[supplierVariants.length - 1].defaultForSupplier = true;
      }
    }

    $scope.validateVariants();
  };  

  $scope.validateVariants = function () {
    const supplierVariants = $scope.item.suppliers;

    if (supplierVariants.length === 0) {
      return;
    }

    const duplicatedStockCodes = [];
    const supplierDefaultCheck = {};
    const errors = [];
    
    supplierVariants.forEach((variant, idx) => {
      // Check if the combination of stockCode and supplierId already exists in duplicatedStockCodes
      const isDuplicate = duplicatedStockCodes.some(
        (item) =>
          item.stockCode === variant.stockCode &&
          item.supplierId === variant.supplierId
      );

      if (isDuplicate) {
        // If it's a duplicate, add an error
        errors.push({
          stockCode: variant.stockCode,
          supplierId: variant.supplierId,
          errorType: "duplicatedStockCode",
          line: idx + 1,
        });
      } else {
        // If not, add the combination to duplicatedStockCodes (Avoiding redundant error checks)
        duplicatedStockCodes.push({
          stockCode: variant.stockCode,
          supplierId: variant.supplierId,
          errorType: "duplicatedStockCode",
          line: idx + 1,
        });
      }

      // Initialize supplierDefaultCheck for each supplierId
      if (!supplierDefaultCheck[variant.supplierId]) {
        supplierDefaultCheck[variant.supplierId] = {
          hasDefault: false,
          supplierName: variant.supplierName,
        };
      }
      // Check if this variant is marked as defaultForSupplier
      if (variant.defaultForSupplier) {
        supplierDefaultCheck[variant.supplierId].hasDefault = true;
      }     
    });

    // Add missingDefaultForSupplier errors
    Object.entries(supplierDefaultCheck).forEach(([supplierId, { hasDefault, supplierName }]) => {
      if (!hasDefault) {
        errors.push({
          supplierId,
          supplierName,
          errorType: "missingDefaultForSupplier",
        });
      }
    });
    
    // Build error message for display
    if (errors.length > 0) {
      const errorMessages = errors.map(
        (error) =>
        {
          if (error.errorType === "duplicatedStockCode") {  
            return `The Stock Code '${error.stockCode}' cannot be used by the same supplier (line: ${error.line}).`
          }
          else if (error.errorType === "missingDefaultForSupplier") {  
            return `At least one variant must be marked as default for the supplier ${error.supplierName}.`
          }
        }
      );

      $timeout(() => {
        $scope.isStockCodeValid = false;
        $scope.errorMessages = errorMessages; // Store the errors in an array
      });
    } else {
      $timeout(() => {
        $scope.isStockCodeValid = true;
        $scope.errorMessages = []; // Clear errors
      });
    }
  };

  $scope.updateDefaultForSupplier = function (index) {
    const updatedItemSupplier = $scope.item.suppliers[index];
    
    // Prevent unchecking the current checkbox if it is already selected
    if (!updatedItemSupplier.defaultForSupplier) {
      updatedItemSupplier.defaultForSupplier = true;
      return;
    }

    // Prevent unchecking the current checkbox if it is already selected
    if (!updatedItemSupplier.defaultForSupplier) {
      updatedItemSupplier.defaultForSupplier = true;
      return;
    }
  
    // Unmark other suppliers with the same supplierId
    $scope.item.suppliers.forEach((itemSupplier, itemSupplierIndex) => {
      if (itemSupplierIndex !== index && itemSupplier.supplierId == updatedItemSupplier.supplierId) {
        if (updatedItemSupplier.defaultForSupplier) {
          itemSupplier.defaultForSupplier = false;
        }
      }
    });

    $scope.validateVariants();
  };  

  $scope.formatTaxSelect = function(tax) {
    return tax.rate + ': ' + tax.label + ' (' + tax.amount * 100 + '%)';
  };

  $scope.MinimumStockOnHandEnabled = false;
  features.isEnabled('alpha')
    .then(function(isAlpha) {
      $scope.MinimumStockOnHandEnabled = isAlpha;
    });   
}]);
